<template>
    <div>
        <HeaderPage></HeaderPage>
        <div class="content">
            <SlideShow></SlideShow>
        </div>
        <div class="productDetail">
            <h2>{{ this.rowData.name }}</h2>
            <div>
                <h3>产品介绍：</h3>
                <div v-for="(imgItem,index) in this.rowData.photos" :key="index + 'img'" class="photo">
                    <img :src="imgItem" alt="">
                </div>
                <div v-for="(productsItem, index) in this.rowData.describe" :key="index + 'product'">
                    <p>{{ productsItem}}</p>
                </div>
            </div>
            <div v-if="this.rowData.img">
                <h3>技术参数：</h3>
                <img :src="this.rowData.img" alt="">
            </div>
            <div v-if="this.rowData.advantage">
                <h3>优点：</h3>
                <div v-for="(advantageItem, index) in this.rowData.advantage" :key="index + 'advantage'">
                    <p>{{ advantageItem }}</p>
                </div>
            </div>
            <div v-if="this.rowData.scene">
                <h3>适用场景：</h3>
                <p>{{ this.rowData.scene }}</p>
            </div>
            <div>
                <!-- <h3>经济效益测算：</h3> -->
                <img :src="this.rowData.Image" alt="">
            </div>
        </div>
        <FooterPage></FooterPage>
    </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue';
import SlideShow from '@/components/SlideShow.vue';
import FooterPage from '@/components/FooterPage.vue';

export default {
    name: 'ProductsDetail',
    data() {
        return {
            rowData: [],
        }
    },
    components: {
        HeaderPage,
        SlideShow,
        FooterPage
    },
    watch: {
        '$store.state.custom.productId'(newVal, oldVal) {
            console.log(`count 从 ${oldVal} 变为 ${newVal}`);
            this.rowData = JSON.parse(sessionStorage.getItem('rowData')); // 从 sessionStorage 获取数据
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
        }
    },
    mounted() {
        this.rowData = JSON.parse(sessionStorage.getItem('rowData')); // 从 sessionStorage 获取数据
    }
}
</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}
.photo {
    width: 50%;
    display: inline-block;
}
.photo img {
    height: 300px;
}
.productDetail {
    width: 70%;
    margin: auto;
    text-align: left;
    font-size: 18px;
    line-height: 30px;
}
.productDetail h2 {
    text-align: center;
}
.productDetail img {
    width: 90%;
}
</style>